import Decimal from 'decimal.js-light';

/**
 * 数値をパーセントに変換する
 * 計算結果をそのまま返し、精度・丸め処理は呼び出し元でparsePercentを使用する
 */
export const calculatePercent = (value: number, total: number): number => {
  if (!value) return 0;
  if (!total || total <= 0) return 0;

  const result = new Decimal(value).div(total).times(100);
  return result.toNumber();
};
